import { defineRule, configure } from 'vee-validate';
import { all } from '@vee-validate/rules';
import { REGEXS } from '~/constants/common';
import { localize } from '@vee-validate/i18n';
import en from '@vee-validate/i18n/dist/locale/en.json';
import ja from '@vee-validate/i18n/dist/locale/ja.json';
import zh from '@vee-validate/i18n/dist/locale/zh_CN.json'

export default defineNuxtPlugin(() => {
  const customMessage = {
    en: {
      required: 'This is a required item.',
      email: 'Not a valid email address.',
      confirmed: 'Does not match.',
      max: `Up to 0:{length} characters.`,
      checkValidateEmail: 'Not a valid email address.',
      validEmailInput: 'Not a valid email address.',
      checkCompanyName: 'Not a valid company Name.',
      url: 'The Current field is not a valid URL',
      regex: 'The {field} format is invalid.',
      blockDomain: 'Not a domain format',
      blockEmail: 'Not an email address format',
      checkEndDate: 'Date entered is already past.'
    },
    ja: {
      required: '入力必須項目です。',
      email: '有効なメールアドレスではありません。',
      confirmed: '一致しません。',
      max:`0:{length} 文字以内`,
      checkValidateEmail: '有効なメールアドレスではありません。',
      validEmailInput: '有効なメールアドレスではありません。',
      checkCompanyName: '有効な会社名ではありません。',
      url: '現在のは有効なURLではありません',
      regex: '{field}のフォーマットが正しくありません。',
      blockDomain: 'ドメインのフォーマットではありません。',
      blockEmail: 'メールアドレスのフォーマットではありません。',
      checkEndDate: '過去の日付が入力されています。'
    },
    zh: {
      required: '必填项目。',
      email: '该邮箱地址无效。',
      confirmed: '不一致。',
      max: `0:{length} 字以内`,
      checkValidateEmail: '该邮箱地址无效。',
      validEmailInput: '该邮箱地址无效。',
      checkCompanyName: '公司名称无效。',
      url: '现在的不是一个有效的url',
      regex: '{field}格式无效。',
      blockDomain: '非域名格式。',
      blockEmail: '这非电子邮件地址的格式。',
      checkEndDate: '您填写的是过去的日期！'
    },
  }

  configure({
    generateMessage: localize({
      en: {
        ...en,
        messages: {
          ...en.messages,
          ...customMessage.en
        }
      },
      ja: {
        ...ja,
        messages: {
          ...ja.messages,
          ...customMessage.ja
        }
      },
      zh: {
        ...zh,
        messages: {
          ...zh.messages,
          ...customMessage.zh
        }
      }
    }),
  })
  
  Object.entries(all).forEach(([name, rule]) => {
    defineRule(name, rule);
  });

  // Validates the leftover (not-yet-tagged) text of an email tag input. Empty
  // passes; otherwise it must be a single valid email — the same REGEXS.EMAIL
  // used to decide whether a token becomes a tag, so nothing is silently lost.
  // Must return a boolean (not a string): a returned string would be shown
  // verbatim, bypassing the localized message lookup.
  defineRule('validEmailInput', (value) =>
    !value || value.length === 0 || REGEXS.EMAIL.test(value));

  defineRule('checkValidateEmail', (value) => {
    if (!value || value.length === 0) return true;
    const regex = /^[\x00-\x7F]+$/;
    const temp = regex.test(value)
    return temp || 'checkValidateEmail';
  });

  defineRule('confirmed', (value, [target], ctx) => {
    if (!value || value.length === 0) return true;
    const otherValue = ctx.form[target];
    return value === otherValue;
  });

  defineRule('blockDomain', (value) => {
    if (!value || value.length === 0) return true;
    const regex = /^@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+$/
    return regex.test(value)
  })
  
  defineRule('checkCompanyName', (value) => {
    if (!value || value.length === 0) return true;
    const specialCaseCompanyName = ['FIAÇÃO FIDES'];
    const regex = /^[\x00-\x7F]*$/
    return regex.test(value) || specialCaseCompanyName.includes(value.toUpperCase());
  })

  defineRule('blockEmail', (value) => {
    if (!value || value.length === 0) return true
    const regex = /^[\x00-\x7F]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/
    return regex.test(value)
  })

  defineRule('checkEndDate', (value) => {
    if (!value) return true
    return !(new Date(value).setHours(0,0,0,0) <  new Date().setHours(0,0,0,0))
  })
});
